<template>
  <div style="height: 90vh;">
    <b-container>
      <div
        class="d-flex flex-column justify-content-around login-container mx-auto"
      >
        <div>
          <img width="100" height="100" src="../../assets/img/mdme-logo.png" />
        </div>
        <b-card>
          <div class="mb-3">
            <h1>Sign in</h1>
            <h2 class="assigned-to">
              Enter your credentials to access your account.
            </h2>
          </div>
          <div>
            <form v-on:submit.stop.prevent="onSubmit">
              <div class="form-group">
                <input
                  id="top"
                  type="email"
                  required
                  placeholder="Email"
                  class="form-control form-control-lg"
                  v-model="form.email"
                />
              </div>

              <div class="form-group">
                <input
                  id="bottom"
                  type="password"
                  required
                  placeholder="Password"
                  class="form-control form-control-lg"
                  v-model="form.password"
                />
              </div>
              <div class="row">
                <div class="d-flex w-100">
                  <button
                    type="submit"
                    class="btn-blue w-100"
                    @click.stop.prevent="onSubmit"
                    :disabled="loading"
                  >
                    <span v-if="!loading">Sign In</span>
                    <span v-if="loading">
                      <b-spinner small type="grow" class="spinner"></b-spinner>
                      Loading...
                    </span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </b-card>
        <div>
          <a
            class="pass-link my-auto"
            @click.stop.prevent="
              $router.push('/forgot-password').catch(() => {})
            "
            >Forgot password?</a
          >
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
//import { Auth } from 'aws-amplify';
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
    };
  },
  computed: { ...mapGetters(["getErrors"]) },
  mounted: () => {},
  methods: {
    async onSubmit() {
      this.loading = true;
      const email = this.form.email.toLowerCase();
      const password = this.form.password;

      this.validator(email, password);

      if (this.getErrors.length < 0 || this.getErrors.length == []) {
        await this.$store.dispatch("login", { email, password });
      }

      [this.loading, this.form.password] = [false, ""];
    },
    validator(email, password) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!email || email == "" || !re.test(email)) {
        this.$store.dispatch("createErrors", "Please enter a valid e-mail.");
      }
      if (!password || password == "") {
        this.$store.dispatch("createErrors", "Please enter your password.");
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  height: 70vh;
  padding-top: 15vh;
  max-width: 50vw;
}
</style>
